/* eslint-disable */

import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import logo from "assets/img/logo.png";
import routesAdmin from "routes/admin";
import routesClient from "routes/client";
import { useBetween } from "use-between";
import _user from "_user";
import { useEffect, useState } from "react";

const Sidebar = ({ open, onClose }) => {

  const { user, setUser } = useBetween(_user)
  const [routes, setRoutes] = useState([])

  useEffect(() => {
    if (!user) return
    if (user.tipo === 'admin') {
      setRoutes(routesAdmin)
    } else {
      setRoutes(routesClient)
    }
  }, [user]);

  return (
    <div
      className={`sm:none duration-300 ease-out linear fixed !z-50 flex h-full w-[300px] min-h-full flex-col border-r border-gray-100 bg-white pb-10 shadow-2xl shadow-shadow-500/40 transition-all dark:!border-white/5 dark:!bg-navy-800 dark:text-white dark:shadow-none md:!z-50 lg:!z-50 xl:!z-0 ${open ? "translate-x-0" : "-translate-x-96"
        }`}
    >
      <span
        className="absolute top-4 right-4 block cursor-pointer rounded-full p-1 text-gray-500 transition-all duration-200 hover:rotate-90 hover:bg-gray-100 hover:text-red-500 xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>

      <div className={`mx-[30px] mt-[30px] flex items-center`}>
        <div className="mt-1 ml-1 h-2.5 font-poppins text-[26px] font-bold uppercase text-navy-700 dark:text-white" >
          <img src={logo} alt="logo" className="logo" />
        </div>
      </div>
      <div className="mt-[58px] mb-7 h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent dark:via-white/30" />
      {/* Nav item */}

      <ul className="mb-auto pt-1">
        <Links routes={routes} />
      </ul>

      {/* Nav item end */}
    </div>
  );
};

export default Sidebar;
